
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"settings(5)","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.415 26.415"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 862"}},[_c('g',{attrs:{"data-name":"Group 861"}},[_c('path',{attrs:{"data-name":"Path 7052","d":"M23.51 10.962a11.208 11.208 0 00-1.453-3.434l1.321-2.774-1.849-1.848-2.774 1.32a10.189 10.189 0 00-3.3-1.321L14.528 0h-2.641L10.83 2.906a10.508 10.508 0 00-3.3 1.453L4.755 3.038 2.906 4.755l1.32 2.773a10.189 10.189 0 00-1.321 3.3L0 11.887v2.642l2.906 1.057a12.33 12.33 0 001.321 3.3l-1.321 2.775 1.849 1.849 2.774-1.321a10.508 10.508 0 003.3 1.453l1.057 2.774h2.642l1.057-2.906c.4-.132.925-.264 1.321-.4L14.793 21a7.937 7.937 0 11-1.585-15.717A7.811 7.811 0 0121 14.264l2.245 2.245a3.108 3.108 0 00.264-1.057l2.906-.925v-2.64z","fill":"#fff"}})])]),_c('g',{attrs:{"data-name":"Group 864"}},[_c('g',{attrs:{"data-name":"Group 863"}},[_c('path',{attrs:{"data-name":"Path 7053","d":"M25.888 22.981l-7.793-7.793a5.29 5.29 0 00-6.208-7.264l2.377 2.377a2.616 2.616 0 01-3.7 3.7l-2.377-2.245a5.22 5.22 0 007 6.208l7.793 7.793a1.915 1.915 0 002.774 0 2.036 2.036 0 00.134-2.776z","fill":"#fff"}})])])])
          )
        }
      }
    